import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PurchaseMotionButtonWrapper from 'pricing-pages-ui/components/common/purchaseMotions/PurchaseMotionButtonWrapper';
import { purchaseMotionsSelector, talkToSalesTypeSelector } from 'pricing-pages-ui/selectors/PurchaseMotionSelectors';
import { BUY_ADDITIONAL_CONTACTS, BUY_TOUCHLESS } from 'ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes';
import { APP } from 'pricing-pages-ui/constants/tracking/App';
import { MC_SIDEGRADE_MODAL, SCREENS } from 'pricing-pages-ui/constants/tracking/Locations';
import styled from 'styled-components';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { checkoutProductConfigurationsSelector } from 'pricing-pages-ui/selectors/ProductConfigsSelectors';
import { productForSkuIdSelector, skuSelector } from 'pricing-pages-ui/selectors/ProductsSelectors';
import { useEffect } from 'react';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
const ButtonWrapper = styled.div.withConfig({
  displayName: "MarketingContactsSidegradeModal__ButtonWrapper",
  componentId: "df1ll-0"
})(["display:flex;flex-direction:column;margin:auto;.pm-button{width:300px;height:50px;}"]);

const MarketingContactsSidegradeModal = ({
  onClose,
  history,
  skuId,
  ownedSkuId,
  queryParamTerm
}) => {
  const ttsType = useSelector(talkToSalesTypeSelector);
  const checkoutMCProductConfigurations = useSelector(state => checkoutProductConfigurationsSelector(state, {
    productConfigurations: [createProductConfig({
      skuId
    })]
  }));
  const checkoutOwnedProductConfigurations = useSelector(state => {
    const {
      quantityPackDetails
    } = skuSelector(state, {
      skuId: ownedSkuId
    });

    if (quantityPackDetails.length) {
      return [createProductConfig({
        skuId: quantityPackDetails[0].skuId,
        quantity: 0
      })];
    }

    return [];
  });
  const {
    productLevel,
    apiName
  } = useSelector(state => productForSkuIdSelector(state, {
    skuId
  }));
  const {
    apiName: ownedApiName
  } = useSelector(state => productForSkuIdSelector(state, {
    skuId: ownedSkuId
  }));
  const canBuyTouchless = useSelector(state => purchaseMotionsSelector(state, {
    skuId
  }).includes(BUY_TOUCHLESS));
  useEffect(() => {
    getUsageTracker().track('modalInteraction', {
      action: 'viewed',
      modalName: 'marketing-contacts-sidegrade-modal'
    });
  }, []);
  let purchaseMotions;

  if (productLevel === STARTER) {
    purchaseMotions = [canBuyTouchless ? BUY_TOUCHLESS : ttsType, BUY_ADDITIONAL_CONTACTS];
  } else {
    purchaseMotions = [ttsType, BUY_ADDITIONAL_CONTACTS];
  }

  const upgradeDataMC = {
    app: APP,
    screen: SCREENS.PRODUCTS_PLANS,
    uniqueId: `${MC_SIDEGRADE_MODAL}-${apiName}`,
    upgradeProduct: ApiNameToUpgradeProductMap[apiName]
  };
  const upgradeDataCurrentPlan = {
    app: APP,
    screen: SCREENS.PRODUCTS_PLANS,
    uniqueId: `${MC_SIDEGRADE_MODAL}-${ownedApiName}`,
    upgradeProduct: ApiNameToUpgradeProductMap[ownedApiName]
  };
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    width: 650,
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(H2, {
        className: "m-all-5",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketingContactsBeta.sidegradeModal.title"
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "p-x-10 p-bottom-10 text-center",
      children: /*#__PURE__*/_jsxs("div", {
        className: "m-all-5",
        children: [/*#__PURE__*/_jsx("p", {
          className: "m-top-5",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketingContactsBeta.sidegradeModal.description"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "m-top-10 flex-column",
          children: /*#__PURE__*/_jsxs(ButtonWrapper, {
            children: [/*#__PURE__*/_jsx(PurchaseMotionButtonWrapper, {
              purchaseMotions: purchaseMotions,
              level: 1,
              upgradeData: upgradeDataMC,
              className: "pm-button",
              productConfigurations: checkoutMCProductConfigurations,
              ownsProduct: false,
              trackingSource: MC_SIDEGRADE_MODAL,
              history: history,
              use: "primary",
              queryParamTerm: queryParamTerm
            }), /*#__PURE__*/_jsx(PurchaseMotionButtonWrapper, {
              purchaseMotions: purchaseMotions,
              level: 2,
              use: "secondary",
              className: "m-top-3 m-x-0 pm-button",
              upgradeData: upgradeDataCurrentPlan,
              productConfigurations: checkoutOwnedProductConfigurations,
              ownsProduct: true,
              trackingSource: MC_SIDEGRADE_MODAL,
              history: history,
              nonMerchandiseIdIdentifier: ownedSkuId.toString(),
              queryParamTerm: queryParamTerm,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketingContactsBeta.sidegradeModal.continueCta"
              })
            })]
          })
        })]
      })
    })]
  });
};

export default MarketingContactsSidegradeModal;